import Vue from 'vue';
import Vuex from 'vuex';
import { ROUTE_DASHBOARD } from '../../utils/constants';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        headline: null,
        description: null,
        button: '$vuetify.buttons.back_to_contact',
        buttonUrl: { name: ROUTE_DASHBOARD },
    },
    mutations: {
        WRITE_CONFIRMATION(state, { headline, description, button, buttonUrl }) {
            state.headline = headline;
            state.description = description;
            if (button) state.button = button;
            if (buttonUrl) state.buttonUrl = buttonUrl;
        },
    },
    actions: {
        writeConfirmation({ commit }, confirmation) {
            commit('WRITE_CONFIRMATION', confirmation);
        },
    },
    getters: {
        confirmation: state => {
            return { headline: state.headline, description: state.description, button: state.button, buttonUrl: state.buttonUrl }
        },
    },
}
